/* eslint-disable no-extend-native */
Date.prototype.withoutTime = function() {
  var d = new Date(this)
  d.setHours(0, 0, 0, 0)
  return d
}

String.prototype.validateJSON = function() {
  // eslint-disable-next-line no-new-wrappers
  var d = new String(this)
  d = d.replace(/\s/g, '')
  return JSON.parse(d)
}
